import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import { PayrollFetchDraftEmployeesGraphQLRequest, PayrollFetchDraftEmployeesResponse } from '../types';

const payrollFetchDraftEmployeesQuery = gql`
  query PayrollFetchDraftEmployees($input: FetchDraftEmployeesInput!) {
    payrollFetchDraftEmployees(input: $input) {
      code
      success
      message
      data {
        currentPage
        from
        lastPage
        perPage
        to
        total
        data {
          id
          name
          designation
          department
          email
          employeeSubType
        }
      }
    }
  }
`;

export const getDraftEmployeeList = (input: PayrollFetchDraftEmployeesGraphQLRequest['input']) => {
  return graphQLApi<PayrollFetchDraftEmployeesResponse, PayrollFetchDraftEmployeesGraphQLRequest>({
    query: payrollFetchDraftEmployeesQuery,
    queryVariables: { input },
  });
};
